export default "__VITE_ASSET__Bw$d47CT__"